class NewMegaMenu extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        let menuTimer

        this.activeLink = this.getAttribute("data-active-link")

        let link

        link = this.closest("header-487").querySelector(
            `.mega-menu-link-${this.activeLink.split(" ").join("-")}`
        )
        console.log(
            `.mega-menu-link-${this.activeLink.split(" ").join("-")}`,
            link,
            this.closest("header-487"),
            666
        )

        link.addEventListener("mouseenter", () => {
            clearTimeout(menuTimer)
            this.classList.add("active")
        })

        link.addEventListener("mouseleave", () => {
            menuTimer = setTimeout(() => this.classList.remove("active"), 150)
        })

        this.addEventListener("mouseenter", () => {
            clearTimeout(menuTimer)
        })

        this.addEventListener("mouseleave", () => {
            this.classList.remove("active")
        })
    }
}

customElements.define("new-megamenu", NewMegaMenu)
